import React from "react";
import { useNavigate } from "react-router-dom";
import { FaRegClock, FaRoute, FaArrowRight } from "react-icons/fa";

const HowItWorks = () => {
  const navigate = useNavigate();

  const steps = [
    {
      stepNum: "1",
      stepLabel: "STEP 01",
      title: "CHOOSE YOUR PACKAGE",
      desc: "Select Small Squad (up to 10), All-Star Squad (up to 15), or Big League (up to 20) based on your guest list.",
    },
    {
      stepNum: "2",
      stepLabel: "STEP 02",
      title: "SELECT YOUR SPORT",
      desc: "Lock in Soccer, Basketball, Volleyball, or Indoor Cricket tailored to your crowd's passion.",
    },
    {
      stepNum: "3",
      stepLabel: "STEP 03",
      title: "TELL US PREFERRED DATE & TIME",
      desc: "Submit your requested weekend or weekday party slot so we can verify arena availability instantly.",
    },
    {
      stepNum: "4",
      stepLabel: "STEP 04",
      title: "CUSTOMIZE FOOD, BEVERAGES & EXTRAS",
      desc: "Add pizza, appetizers, lemonade pitchers, or ask for extra sport time or custom party arrangements.",
    },
    {
      stepNum: "5",
      stepLabel: "STEP 05",
      title: "WE CONFIRM AVAILABILITY & FINAL PRICING",
      desc: "Our team contacts you promptly with exact slot confirmation, deposit info, and your Clubworx scheduling link.",
    },
    {
      stepNum: "6",
      stepLabel: "STEP 06",
      title: "SHOW UP AND ENJOY!",
      desc: "Walk through the doors with your sneakers on. Our staff has courts prepped and tables set for pure fun.",
    },
  ];

  const handleStartBooking = () => {
    const finalCta = document.getElementById("final-cta");
    if (finalCta) {
      finalCta.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/contact");
    }
  };

  return (
    <div
      id="how-it-works"
      className="w-full py-20 px-4 md:px-8 lg:px-12 bg-[#050733] select-none text-white border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        {/* Top pill badge */}
        {/* <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primaryBtnHoverColor/40 bg-primaryBtnHoverColor/10 text-primaryBtnHoverColor text-xs sm:text-sm font-semibold tracking-wider uppercase font-subheading mb-4">
          <FaRoute className="text-xs" />
          <span>SIMPLE 6-STEP PROCESS</span>
        </div> */}

        {/* Section Heading */}
        <h2 className="text-3xl sm:text-5xl md:text-6xl font-heading font-black text-white uppercase text-center tracking-tight leading-tight">
          HOW IT WORKS
        </h2>

        {/* Subtitle */}
        <p className="mt-4 text-gray-300 font-subheading text-base sm:text-lg max-w-3xl text-center leading-relaxed">
          From picking your squad size to game-day kickoff, our streamlined
          booking flow makes party planning effortless.
        </p>
        <p className="text-gray-400 font-subheading text-xs sm:text-sm text-center mt-1">
          Powered by our seamless Clubworx court scheduling system.
        </p>

        {/* 6 Step Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full mt-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-[#090d36] border border-white/10 rounded-2xl p-6 sm:p-7 flex flex-col justify-between shadow-lg hover:border-white/20 transition-all duration-200 group"
            >
              <div>
                {/* Card Top: Number + Step Pill */}
                <div className="flex items-center justify-between">
                  <div className="w-10 h-10 rounded-xl bg-primaryBtnHoverColor text-white font-heading font-bold text-lg flex items-center justify-center shadow-md group-hover:scale-105 transition-transform duration-200">
                    {step.stepNum}
                  </div>
                  <span className="text-[11px] font-heading font-medium tracking-wider text-gray-400 border border-white/15 px-2.5 py-0.5 rounded uppercase">
                    {step.stepLabel}
                  </span>
                </div>

                {/* Step Title */}
                <h3 className="text-base sm:text-lg font-heading font-bold text-white uppercase tracking-wide mt-5 leading-snug">
                  {step.title}
                </h3>

                {/* Step Description */}
                <p className="text-gray-300 font-subheading text-xs sm:text-sm leading-relaxed mt-2.5">
                  {step.desc}
                </p>
              </div>

              {/* Card Footer */}
              <div className="mt-6 pt-4 border-t border-white/10 flex items-center gap-2 text-xs font-subheading text-primaryBtnHoverColor">
                <FaRegClock className="text-xs flex-shrink-0" />
                <span>Clear &amp; stress-free coordination</span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Button */}
        {/* <div className="mt-12 text-center">
          <button
            onClick={handleStartBooking}
            className="bg-primaryBtnHoverColor hover:bg-red-800 text-white font-heading font-bold text-sm sm:text-base px-8 py-4 rounded-lg shadow-lg shadow-red-950/40 uppercase tracking-wider transition-all duration-200 flex items-center justify-center gap-2.5 cursor-pointer mx-auto hover:scale-[1.02] active:scale-95"
          >
            <span>START YOUR PARTY REQUEST</span>
            <FaArrowRight className="text-xs" />
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default HowItWorks;
